export function getWeekdayLocale(localeName: string, weekDay: any) {
  const format = new Intl.DateTimeFormat(localeName, { weekday: weekDay }).format;
  return [...Array.from({ length: 7 }).keys()]
    .map(day => format(new Date(Date.UTC(2021, 1, day + 1))));
}
